<script setup lang="ts">
import { type PropType, ref } from 'vue';
import type { ResetPasswordThirdStepData } from '../types/steps';
import BaseFormGroup from '~/shared/components/form/base-form-group.vue';
import BaseInput from '~/shared/components/form/input/base-input.vue';

defineProps({
  passwordErrors: {
    type: Object as PropType<{ password: string, passwordConfirmation: string }>,
    required: true,
  },
});

const data = defineModel({
  type: Object as PropType<ResetPasswordThirdStepData>,
  required: true,
});
</script>

<template>
  <div class="flex flex-col gap-4 w-80 relative">
    <BaseFormGroup name="password" :error="passwordErrors?.password" label="Create new password">
      <BaseInput
        id="password"
        v-model="data.password"
        name="password"
        type="password"
        placeholder="Enter password"
        :error="passwordErrors?.password"
      />
    </BaseFormGroup>

    <BaseFormGroup name="password-confirm" :error="passwordErrors?.passwordConfirmation" label="Confirm new password">
      <BaseInput
        id="password-confirm"
        v-model="data.passwordConfirmation"
        name="password-confirm"
        type="password"
        placeholder="Enter password again"
        :error="passwordErrors?.passwordConfirmation"
      />
    </BaseFormGroup>
  </div>
</template>
